import React, { useState } from 'react'
import { LuChevronRight } from 'react-icons/lu'

const HandsOnLearningData = [
  {
    heading: 'Laboratory Experiences',
    para: 'Students gain hands-on experience with industry-standard equipment and tools, developing technical proficiency and practical skills.',
  },
  {
    heading: 'Industry Internships',
    para: 'Immersive work experiences in real-world settings, allowing students to apply their knowledge and gain valuable insights into industry practices.',
  },
  {
    heading: 'Project-Based Assignments',
    para: 'Complex projects that require students to collaborate, solve problems, and apply their knowledge in a practical context.',
  },
]

const HandsOnLearningCard = ({ data, defaultOpen }) => {
  const [open, setOpen] = useState(defaultOpen)
  const { heading, para } = data

  return (
    <div className={`accordion_item${open ? ' open' : ''}`}>
      <button className='accordion_btn' aria-expanded={open} onClick={() => setOpen(!open)}>
        {heading}
        <LuChevronRight className='accordion_chevron' size={20} />
      </button>
      {open && <p className='accordion_panel'>{para}</p>}
    </div>
  )
}

const HandsOnLearning = () => {
  return (
    <section className='home_section'>
      <span className='home_eyebrow'>Practice</span>
      <h2 className='home_heading'>Hands-on learning</h2>
      <p className='home_lead'>We believe in the power of hands-on learning to solidify understanding and develop practical skills. Our programs give students ample opportunities to apply their knowledge in real-world scenarios.</p>
      <div className='accordion'>
        {HandsOnLearningData.map((elm, index) => (
          <HandsOnLearningCard data={elm} key={index} defaultOpen={index === 0} />
        ))}
      </div>
    </section>
  )
}

export default HandsOnLearning
